var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareBox(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.944 5.05566L9.99957 2.11122L7.05512 5.05566L6.27734 4.27789L9.99957 0.555664L13.7218 4.27789L12.944 5.05566Z",
    fill: "#33A0AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.44434 1.33301H10.5554V12.9997H9.44434V1.33301Z",
    fill: "#33A0AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.5551 19.6663H4.44401C3.49957 19.6663 2.77734 18.9441 2.77734 17.9997V7.99967C2.77734 7.05523 3.49957 6.33301 4.44401 6.33301H8.3329V7.44412H4.44401C4.11068 7.44412 3.88845 7.66634 3.88845 7.99967V17.9997C3.88845 18.333 4.11068 18.5552 4.44401 18.5552H15.5551C15.8885 18.5552 16.1107 18.333 16.1107 17.9997V7.99967C16.1107 7.66634 15.8885 7.44412 15.5551 7.44412H11.6662V6.33301H15.5551C16.4996 6.33301 17.2218 7.05523 17.2218 7.99967V17.9997C17.2218 18.9441 16.4996 19.6663 15.5551 19.6663Z",
    fill: "#33A0AC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBox);
export default __webpack_public_path__ + "static/media/share-box.2e906410f3f9ec735449024b18ad8488.svg";
export { ForwardRef as ReactComponent };